import React from 'react';
import styled from 'styled-components';
// Styled component for the header container
const FooterContainer = styled.footer`
  width: 100%;
  height: 40px;
  left: 0px;
  bottom: 0px;
  background: #3a3a3a;
`;

const Content = styled.p`
  text-align: center;
  margin: auto 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #929292;
`;

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <FooterContainer>
      <Content>
        Copyright Bharat Soka Gakkai © {currentYear}. All rights reserved.
      </Content>
    </FooterContainer>
  );
}
